import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page not found — Nexsol Labs"
        description="The page you were looking for doesn't exist."
        path="/404"
      />
      <section className="container-page flex flex-1 flex-col items-center justify-center py-32 text-center">
        <p className="font-mono text-sm text-accent-400">404</p>
        <h1 className="mt-3 font-display text-4xl font-semibold text-white md:text-5xl">
          This page doesn't exist.
        </h1>
        <p className="mt-4 max-w-md text-white/65">
          It may have moved, been removed, or never existed in the first place.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
          <Link to="/contact" className="btn-ghost">
            Contact us
          </Link>
        </div>
      </section>
    </>
  );
}
